module.exports = __webpack_public_path__ + "img/5_dp.9dd42645.png";